module.exports = __webpack_public_path__ + "img/demand.94c51e6c.svg";